import { render, staticRenderFns } from "./UserCardRightsDriver.vue?vue&type=template&id=7cd297d2&scoped=true&"
import script from "./UserCardRightsDriver.vue?vue&type=script&lang=ts&"
export * from "./UserCardRightsDriver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd297d2",
  null
  
)

export default component.exports